import React, { useState } from 'react';
import { Panel, FormControl } from 'react-bootstrap';

const CommentsInfo = ({ comment, onCommentChange, isEditable, validations }) => {
      if(!comment){
          return(
              
    //  <Panel collapsible ={isEditable || comment !== ''} header="Comments " > 
     <Panel defaultExpanded={true} header="Comments " > 
     
        {isEditable ? (
            <FormControl
                componentClass="textarea"
                placeholder="Enter comment..."
                name="comment"
                value={comment}
                onChange={onCommentChange}
                rows="7"
                maxLength="1000"
                style={{ resize: 'vertical' }}
            />
        ) : (
            <p>{comment}</p>
        )} 
        
        {validations &&
            validations.comment && (
                <p style={{ color: '#CF142B', margin: 5 }}>{validations.comment}</p>
            )}
     </Panel> 
     
          );
      }
      else{
          
          return(
            // <Panel collapsible ={isEditable || comment !== ''} header=" Comments⚠️" > 
            <Panel defaultExpanded={true} header=" Comments⚠️" > 
                     {isEditable ? (
                        <FormControl
                        componentClass="textarea"
                        placeholder="Enter comment..."
                        name="comment"
                        value={comment}
                        onChange={onCommentChange}
                        rows="7"
                        maxLength="1000"
                        style={{ resize: 'vertical' }}
                        />
                        ) : (
                        <p>{comment}</p>
                     )} 
                {validations &&
                validations.comment && (
                <p style={{ color: '#CF142B', margin: 5 }}>{validations.comment}</p>
                 )}
                 
                 </Panel>
          );
      } 
     };

export default CommentsInfo;
